var detail;

(function() {
	var grid, gridIsActive, bpMobile, bpMedium, helpers, lazyloader;



	/// 1.0
	/// Define basic helpers
	helpers = {
		getColumnWidth: function(grid) {
			var padding = parseInt(grid.css('padding-left')) * 2,
					windowWidth = $(window).width();

			if (windowWidth < 860) {
				return (grid.width() - padding) / 2;
			} else {
				return (grid.width() - padding) / 3;
			}
		},

		refreshGrid: function() {
			if ($(window).width() > bpMobile) {
				grid.masonry({
					columnWidth: helpers.getColumnWidth(grid),
					percentPosition: true,
					transitionDuration: 0
				});

				gridIsActive = true;
			} else if (gridIsActive) {
				grid.masonry('destroy');

				gridIsActive = false;
			}
		},

		resizeImages: function() {
			var img, smallHeight, largeHeight,
					small = $('.thumb--small'),
					large = $('.thumb--large');

			small.each(function() {
				img = $(this).find('img');

				if ($(window).width() < bpMedium) {
					$(this).height('auto');
					smallHeight = true;
				} else if (img.hasClass('loaded')) {
					smallHeight = img.height();
					smallHeight = Math.floor(smallHeight);
					$(this).height(smallHeight);
				}
			});

			if(smallHeight) {
				large.each(function() {
					if ($(window).width() < bpMedium) {
						$(this).height('auto');
					} else if($(this).find('img').hasClass('loaded')) {
						largeHeight = smallHeight * 2;
						$(this).height(largeHeight);
					}
				});
			}
		}
	};


	/// 2.0
	/// Setup detail popup functions
	detail = {
		init: function() {
			this.bindUIActions();

			if(this.getQueryVariable('project')) {
				this.open(this.getQueryVariable('project'));
			}
		},

		bindUIActions: function() {
			var that = this;

			$('.thumb').each(function() {
				$(this).on('click', function() {
					var detail_url = $(this).data('url');

					if(!that.isOpened){
						that.open(detail_url);
					}
				});
			});
		},

		initPopup: function() {
			var that = this;

			this.popup = $('.popup__inner');
			$('.popup__push').css('height', $(window).height() * 2 + 'px');

			this.initLazyload();
			this.initScrollActions();
			this.initUIActions();
			this.removeBodyScrollbar(true);

			setTimeout(function() {
				that.popup.addClass('loaded');
			}, 10);
		},

		initLazyload: function() {
			var that = this;

			this.lazyloader = new LazyLoad({
				data_src: "original",
				data_srcset: "original-set",
				container: document.getElementById('popup'),
				show_while_loading: true,
				threshold: 500,
				callback_load: function(img) {
					$(img).addClass('loaded');
					that.lazyloader.update();
				}
			});
		},

		initUIActions: function() {
			var that = this;

			$('#popup').on('click', function() {
				that.closeAni();
			});

			that.popup.on('click', function(e) {
				e.stopPropagation();
			});

			$('#close').on('click', function() {
				that.closeAni();
			});
		},

		checkScrollBars: function(containers){
	    var b = $('body');
	    var normalw = 0;
	    var scrollw = 0;
	    if(b.prop('scrollHeight')>b.height()){
	        normalw = window.innerWidth;
	        scrollw = normalw - b.width();

	        for (var i = 0; i < containers.length; i++)  {
	        	var container = containers[i];

	        	console.log(container);
	        	$(container).css('margin-right', '-'+scrollw+'px');
	        }
	    }
		},

		initScrollActions: function() {
			var scroll, pos, height, that = this;

			$('#popup').on('scroll', function() {
				pos = that.popup.position().top;
				pos *= -1;
				height = $('.popup__container').height();

				if(pos > height) that.close();
			});
		},

		open: function(detail_url) {
			var that = this;

			this.isOpened = true;

			$.ajax({
				url: detail_url,
				type: 'GET',
				context: document.body,
				success: function(data) {
					$('body').append(data);

					that.initPopup();
				}
			});

			this.changeLocation(detail_url);
		},

		removeBodyScrollbar: function(removeBar) {
			if (removeBar) {

				// this.checkScrollBars([$('#popup')]);
				// console.log('remove scrollbar');
				// $('body').addClass('no-scroll');
				if($(window).width() < bpMobile) {
					$('#popup .popup__inner').css('right', 16 - this.getScrollbarWidth() + 'px');
				} else {
					$('#popup .popup__inner').css('right', 51 - this.getScrollbarWidth() + 'px');
				}
			} else {
				// this.checkScrollBars([$('body')]);
				// console.log('add scrollbar');
				// $('body').removeClass('no-scroll');
				// $('body').css('padding-right', '0');
			}
		},

		changeLocation: function(detail_url) {
			var current = window.location.origin + window.location.pathname;

			window.history.pushState('object or string', 'title', window.location.pathname + '?project=' + detail_url);
		},
		
		getQueryVariable: function(variable) {
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
			       var pair = vars[i].split("=");
			       if(pair[0] == variable){return pair[1];}
			}
			return(false);
		},

		getScrollbarWidth: function() {
			var outer = document.createElement("div");
			outer.style.visibility = "hidden";
			outer.style.width = "100px";
			outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

			document.body.appendChild(outer);

			var widthNoScroll = outer.offsetWidth;
			// force scrollbars
			outer.style.overflow = "scroll";

			// add innerdiv
			var inner = document.createElement("div");
			inner.style.width = "100%";
			outer.appendChild(inner);        

			var widthWithScroll = inner.offsetWidth;

			// remove divs
			outer.parentNode.removeChild(outer);

			return widthNoScroll - widthWithScroll;
		},

		close: function() {
			this.lazyloader.destroy();
			this.isOpened = false;
			$('#popup').remove();
			window.history.pushState('object or string', 'title', window.location.pathname);
			this.removeBodyScrollbar(false);

			$('#information').parent().removeClass('menu__item--active');
		},

		closeAni: function() {
			var that = this, height, pos;

			height = this.popup.height();

			this.popup.css('transform', 'translate3d(0,' + height * -1.2 + 'px,0)');

			setTimeout(function() {
				that.close();
			}, 300);
		}
	};



	/// 3.0
	/// Initialize lazyloader
	grid = $('.grid');
	gridIsActive = false;
	bpMobile = 640;
	bpMedium = 860;

	lazyloader = new LazyLoad({
		data_src: "original",
		data_srcset: "original-set",
		show_while_loading: true,
		threshold: 500,
		callback_load: function(img) {
			if($(img).hasClass('thumb__img')) $(img).parent().parent().addClass('loaded');
			helpers.refreshGrid();
			lazyloader.update();
		}
	});

	helpers.refreshGrid();



	/// 4.0
	/// Call window ready functions
	$(window).ready(function() {
		detail.init();
		detail.checkScrollBars([$('body')]);
		helpers.resizeImages();
		helpers.refreshGrid();

		$('#information').on('click', function() {
			var informationUrl = $(this).data('url');
			$(this).parent().addClass('menu__item--active');

			detail.open(informationUrl);
		});
	});



	/// 5.0
	/// Call window load functions
	$(window).on('load', function() {
		helpers.resizeImages();
		helpers.refreshGrid();
	});



	/// 5.0
	/// Call window resize functions
	$(window).on('resize', function() {
		helpers.resizeImages();
		helpers.refreshGrid();
	});
})();